/**
 * Status GETs must not reuse a cached 304. Express sends ETags; webpack can
 * forward 304 with an empty body. `response.ok` is false for 304, so
 * `getAuthStatus` would return `kind: 'error'` and skip completed-login Bind.
 * Lives here (not `api.ts`) so Okta services do not import the API wrapper.
 */
async function fetchNoStore(url: string, init: RequestInit): Promise<Response> {
  const response = await globalThis.fetch(url, { ...init, cache: 'no-store' });
  if (response.status !== 304) {
    return response;
  }
  return globalThis.fetch(url, { ...init, cache: 'reload' });
}

export async function fetchAuthStatusHttp(
  url: string,
  init: RequestInit,
): Promise<{ httpStatus: number; ok: boolean; body: unknown }> {
  const response = await fetchNoStore(url, init);
  let body: unknown = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  return {
    httpStatus: response.status,
    ok: response.ok,
    body,
  };
}
